/* eslint-disable jsx-a11y/anchor-is-valid */

import { useState, useEffect } from "react";
import "./HeaderList.scss";

function HeaderList() {
  const [currentTime, setCurrentTime] = useState({
    date: "",
    time: "",
  });

  const updateTime = () => {
    const now = new Date();

    const options = {
      timeZone: "Asia/Bangkok",
    };

    // Ngày tháng theo Thái Lan
    const date = now.toLocaleDateString("th-TH", {
      ...options,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    // Giờ Thái Lan
    const time = now.toLocaleTimeString("th-TH", {
      ...options,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    setCurrentTime({
      date,
      time,
    });
  };

  useEffect(() => {
    updateTime();

    const intervalId = setInterval(
      updateTime,
      1000
    );

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="header_list">
      <div className="wrap">
        <ul>
          <li>
            {/* Thailand Time */}
            <a>
              <div className="vn-date">
                <div
                  className="global_ring"
                  style={{ display: "block" }}
                >
                  <div className="currenttime">
                    <span className="currenttime_date">
                      {currentTime.date}
                    </span>

                    <span className="currenttime_time">
                      {currentTime.time}
                    </span>

                    <span>(GMT+7)</span>
                  </div>
                </div>
              </div>

              {/* Cờ Thái Lan */}
              {/* <img
                src="/iconth.png"
                alt="Thailand"
                className="icon_vi"
              /> */}
            </a>

            {/* Online */}
            <a href="" className="atructuyen">
              <p className="online_title">
                ออนไลน์:
              </p>

              <div className="online_count">
                <div className="onlineNumShow">
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                  <span>8</span>
                  <span>9</span>
                  <span>0</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default HeaderList;